





















import Vue from 'vue';
import MpGroupField from './MpGroupField.vue';
import ContainRelation from './ContainRelation.vue';
import customerVuex from '../../../customer/vuex/common';
import commonVuex from '../../../common/vuex/common';
import settingsClient from '../../../settings/apis';
import { TopicFilter } from '../../../customer/models/CustomerFilter';

export default Vue.extend({
  mixins: [customerVuex, commonVuex],
  components: {
    MpGroupField,
    ContainRelation,
  },
  computed: {
  },
  methods: {
    loadTopics() {
      settingsClient.getTopics().success((r: any) => {
        this.$store.commit('SET_TOPICS', r.topics);
        this.$emit('loaded');
      });
    },
    updateNotIn(notIn: boolean) {
      const v = this.customerFilter.topicQuery;
      v.notIn = notIn;
      this.updateTopiceFilter(v);
    },
    updateTopics(topics: number[]) {
      const v = this.customerFilter.topicQuery;
      v.topics = topics;
      this.updateTopiceFilter(v);
    },
    updateTopiceFilter(filter: TopicFilter) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'topicQuery',
        value: filter,
      });
    },
  },
  beforeMount() {
    this.loadTopics();
  },
});
